import _ from 'lodash';
import { FormControlLabel } from '@material-ui/core';
import { RadioButton, RadioButtonGroup } from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSelect, { MultiSelectOption } from '../../../common/MultiSelect';
import OPERATORS from '../constants/operators';
import { sortRowValues } from '../helpers/sortValues';
import ColumnFilter from './ColumnFilter';

const initialCurrent = {
  operator: OPERATORS.CONTAINS,
  string: '',
  valid: false,
};

class TextFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = (props) => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (!value || value === '' || (Array.isArray(value) && value.length === 0)) {
        return new MultiSelectOption(null, '(Blank)');
      }

      if ((Array.isArray(value) && value.length)) {
        return value.map((v) => new MultiSelectOption(v));
      }

      return new MultiSelectOption(value);
    })
    .flatten()
    .uniqBy('value')
    .value()
    .sort(sortRowValues);

  isValid = (multiSelectValues, string) => (multiSelectValues && multiSelectValues.length > 0) || !!string;

  render() {
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                value={current.multiSelectValues}
                onChange={(value) => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: this.isValid([value], current.string),
                })}
                options={this.state.multiSelectOptions}
              />
            </div>
            <div className="advanced-filter__fields">
              <RadioButtonGroup
                onChange={(event, operator) => { setCurrent({ ...current, operator }); }}
                name="textFilter"
                value={current.operator}
              >
                <FormControlLabel
                  value={OPERATORS.CONTAINS}
                  control={<RadioButton />}
                  label={<FormattedMessage id="filter-component.label.contains" />}
                />
                <FormControlLabel
                  value={OPERATORS.STARTS_WITH}
                  control={<RadioButton />}
                  label={<FormattedMessage id="filter-component.label.starts-with" />}
                />
              </RadioButtonGroup>
            </div>

            <div className="advanced-filter__fields">
              <input
                className="text-input"
                onChange={(event) => setCurrent({
                  ...current,
                  string: event.target.value,
                  valid: this.isValid(current.multiSelectValues, event.target.value),
                })}
                value={current.string}
              />
            </div>
          </div>
        )}
      />
    );
  }
}

TextFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default TextFilter;
